import React from "react";
import { formatGBP } from "../../utils/currency";

interface PropsType {
  [x: string]: any;
}
export default function FundCalculation(props: PropsType) {
  return (
    <div className="calculation_box">
      <div className="calculation_main">
        <div>
          <p>
            Total Fund Value: <span>{formatGBP(props?.calculatedData)}</span>
          </p>
        </div>
      </div>
    </div>
  );
}
